import { BankType, ProductIds } from '@sparrow-card/sparrow-card-constants';
import pdfA02 from 'assets/pdf/Sparrow Credit Card Agreement A02.pdf';
import pdfA01 from 'assets/pdf/Sparrow Credit Card Agreement.pdf';
import pdfA04 from 'assets/pdf/Sparrow Rewards-FNBL Credit Card Agreement.pdf';
import pdfFocus from 'assets/pdf/Sparrow Rewards-Focus Credit Card Agreement.pdf';

export const getPdfPath = (productId: ProductIds | string | null, bankPartner?: BankType) => {
  if (bankPartner === BankType.Focus) {
    return pdfFocus;
  }

  switch (productId) {
    case ProductIds.A04:
      return pdfA04;
    case ProductIds.A01:
      return pdfA01;
    case ProductIds.A02:
      return pdfA02;
    default:
      return pdfA02;
  }
};
